import { property, supertypeClass } from '@haventech/amorphic';
import { IsomorphicPersistent } from '@hit/amorphic-types';
import { Policy } from '../../common/js/customer/Policy';
import { FollowupClosingSources } from '../js/interfaces/CoverpathTypes';

@supertypeClass({ toClient: true, toServer: true })
export class FollowupSummary extends IsomorphicPersistent {
  @property({ getType: () => Policy })
  policy: Policy;

  @property({ comment: 'Indicates how many followups have ever opened for this policy' })
  openCount: number;

  @property({ comment: 'Indicates how many followups have ever closed for this policy' })
  closeCount: number;

  @property({ comment: 'Indicates the date last followup is opened' })
  lastOpenedDate: Date;

  @property({ comment: 'Indicates the date last followup is closed' })
  lastClosedDate: Date;

  @property({ comment: 'Either customer or ops' })
  closedBy: FollowupClosingSources;

  constructor() {
    super();
  }

  static new(policy: Policy, openCount = 1, lastOpenedDate = new Date()) {
    return new FollowupSummary().init(policy, openCount, lastOpenedDate);
  }

  init(policy: Policy, openCount: number, lastOpenedDate: Date): FollowupSummary {
    this.policy = policy;
    this.openCount = openCount;
    this.lastOpenedDate = lastOpenedDate;
    this.closeCount = 0;
    return this;
  }

  public open(lastOpenedDate = new Date()): void {
    this.lastOpenedDate = lastOpenedDate;
    this.openCount++;
  }

  public close(toBeClosedCnt, source: FollowupClosingSources, lastClosedDate = new Date()): void {
    this.closedBy = source;
    this.lastClosedDate = lastClosedDate;
    this.closeCount += toBeClosedCnt;
  }

  public getOpenCustomerFollowupsCountInHit(): number {
    return this.openCount - this.closeCount;
  }
}
